export default __webpack_public_path__ + "static/media/game_logo.1bdd4ed4.png";